// Store targets globally
let currentTargets = []

var getCurrentTargetsForPageOverlays = function () {
	if (!Array.isArray(currentTargets)) {
		currentTargets = [currentTargets]
	}
	return currentTargets
}

var setCurrentTargetsForPageOverlays = function (targets) {
	currentTargets = targets
}

export { getCurrentTargetsForPageOverlays, setCurrentTargetsForPageOverlays }
